import aboutPhoto from "../assets/about_photo.jpeg";
import heroProductMarkup from "../assets/features/Hero Product Markup.png";
import finalCtaScreenshot from "../assets/features/Final CTA Screenshot.png";
import structuredLessons from "../assets/mockups/structured_lessons.png";

export const SITE_URL = "https://speakyourmenu.com";

export function toAbsoluteAssetUrl(assetPath) {
  if (!assetPath) return "";
  if (/^https?:\/\//i.test(assetPath)) return assetPath;
  return `${SITE_URL}${assetPath.startsWith("/") ? assetPath : `/${assetPath}`}`;
}

export const SEO_SHARE_IMAGES = Object.freeze({
  homepage: toAbsoluteAssetUrl(finalCtaScreenshot),
  features: toAbsoluteAssetUrl(heroProductMarkup),
  about: toAbsoluteAssetUrl(aboutPhoto),
  contact: toAbsoluteAssetUrl(heroProductMarkup),
  blog: toAbsoluteAssetUrl(structuredLessons),
  brand: toAbsoluteAssetUrl(finalCtaScreenshot),
});